/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FinancialHistoryPeriod = {
  period_label: string;
  measurement_end_date: string;
  scenario: FinancialHistoryPeriod.scenario;
  revenue: number | null;
  revenue_growth: number | null;
  gross_margin: number | null;
  ebitda: number | null;
  net_income: number | null;
  fcf: number | null;
  employees: number | null;
};
export namespace FinancialHistoryPeriod {
  export enum scenario {
    HISTORICAL = 'historical',
    PROJECTION = 'projection',
  }
}

